(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cosmo-italian-journey"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cosmo-italian-journey')) {
    customElements.define('cosmo-italian-journey', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.buttons = [...this.querySelectorAll('[data-region]')];
        this.panels = [...this.querySelectorAll('[data-region-panel]')];
        this.routes = [...this.querySelectorAll('[data-map-route]')];
        this.dialog = this.querySelector('dialog');
        this.onClick = event => {
          const region = event.target.closest('[data-region]');
          if (region) { this.select(region.dataset.region, true); return; }
          const trigger = event.target.closest('[data-story-trigger]');
          if (trigger && this.dialog && typeof this.dialog.showModal === 'function') {
            event.preventDefault();
            const panel = trigger.closest('[data-region-panel]');
            this.lastTrigger = trigger;
            this.querySelector('[data-dialog-title]').textContent = panel.dataset.regionName;
            this.querySelector('[data-dialog-body]').replaceChildren(panel.querySelector('[data-story-content]').cloneNode(true));
            this.dialog.showModal();
            document.documentElement.classList.add('cosmo-dialog-open');
          }
          if (event.target.closest('.cosmo-story-dialog__close')) this.dialog.close();
        };
        this.onKeydown = event => {
          const button = event.target.closest('.cosmo-region-button');
          if (!button || !['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const buttons = [...this.querySelectorAll('.cosmo-region-button')];
          let index = buttons.indexOf(button);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = buttons.length - 1;
          else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          buttons[index].focus();
          this.select(buttons[index].dataset.region, true);
        };
        this.onClose = () => { document.documentElement.classList.remove('cosmo-dialog-open'); if (this.lastTrigger && this.lastTrigger.isConnected) this.lastTrigger.focus(); };
        this.onBackdrop = event => { if (event.target !== this.dialog) return; const rect = this.dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close(); };
        this.onBlockSelect = event => { if (this.panels.some(panel => panel.dataset.regionPanel === event.detail.blockId)) this.select(event.detail.blockId, false); };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.dialog.addEventListener('close', this.onClose);
        this.dialog.addEventListener('click', this.onBackdrop);
        this.classList.add('is-ready');
        if (this.panels[0]) this.select(this.panels[0].dataset.regionPanel, false);
      }
      select(id, announce) {
        this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.region === id)));
        this.panels.forEach(panel => { panel.hidden = panel.dataset.regionPanel !== id; });
        this.routes.forEach(route => route.classList.toggle('is-active', route.dataset.mapRoute === id));
        const panel = this.panels.find(item => item.dataset.regionPanel === id);
        if (announce && panel) this.querySelector('[data-region-status]').textContent = panel.dataset.regionName + ': ' + panel.querySelector('.cosmo-region-card__products').textContent;
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.dialog) { if (this.dialog.open) this.dialog.close(); this.dialog.removeEventListener('close', this.onClose); this.dialog.removeEventListener('click', this.onBackdrop); }
        document.documentElement.classList.remove('cosmo-dialog-open');
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cosmo-news-preview"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanups = new Map();
    const sessionKey = 'cosmo-news-teaser-seen-v1';
    const initialize = (root) => {
      if (!root || cleanups.has(root.id) || root.dataset.newsPopupEnabled !== 'true') return;
      const popup = root.querySelector('[data-news-popup]');
      if (!popup || window.Shopify?.designMode) return;
      try { if (sessionStorage.getItem(sessionKey)) return; } catch (_) {}
      const controller = new AbortController();
      let ready = false;
      let shown = false;
      let dismissed = false;
      let frame = 0;
      const threshold = Number(root.dataset.newsScrollThreshold || 35) / 100;
      const hasObstruction = () => {
        const active = document.activeElement;
        if (active?.closest('form, input, textarea, select, [contenteditable="true"]')) return true;
        const overlays = document.querySelectorAll('dialog[open], [aria-modal="true"], .drawer.active');
        for (const overlay of overlays) {
          const rect = overlay.getBoundingClientRect();
          if (rect.width && rect.height && getComputedStyle(overlay).visibility !== 'hidden') return true;
        }
        const popupLeft = Math.max(12, window.innerWidth - 424);
        const popupTop = window.innerHeight - 200;
        for (const form of document.forms) {
          const rect = form.getBoundingClientRect();
          if (rect.width && rect.height && rect.bottom > popupTop && rect.top < window.innerHeight && rect.right > popupLeft && rect.left < window.innerWidth) return true;
        }
        return false;
      };
      const maybeShow = () => {
        frame = 0;
        if (!ready || dismissed || document.visibilityState !== 'visible') return;
        if (shown) {
          popup.hidden = hasObstruction();
          return;
        }
        const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollableHeight <= 0 || window.scrollY / scrollableHeight < threshold || hasObstruction()) return;
        shown = true;
        popup.hidden = false;
        try { sessionStorage.setItem(sessionKey, '1'); } catch (_) {}
      };
      const requestCheck = () => { if (!frame && !dismissed) frame = requestAnimationFrame(maybeShow); };
      const timer = window.setTimeout(() => { ready = true; requestCheck(); }, 10000);
      const close = () => {
        const hadFocus = popup.contains(document.activeElement);
        dismissed = true;
        popup.hidden = true;
        if (hadFocus) root.querySelector('[data-news-hub-link]')?.focus({ preventScroll: true });
      };
      popup.querySelector('[data-news-popup-close]').addEventListener('click', close, { signal: controller.signal });
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !popup.hidden) close(); }, { signal: controller.signal });
      window.addEventListener('scroll', requestCheck, { passive: true, signal: controller.signal });
      window.addEventListener('resize', requestCheck, { passive: true, signal: controller.signal });
      document.addEventListener('focusout', requestCheck, { signal: controller.signal });
      document.addEventListener('focusin', requestCheck, { signal: controller.signal });
      document.addEventListener('visibilitychange', requestCheck, { signal: controller.signal });
      cleanups.set(root.id, () => { controller.abort(); clearTimeout(timer); cancelAnimationFrame(frame); });
    };
    const initializeAll = () => document.querySelectorAll('[data-news-preview]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-news-preview]').forEach(initialize));
    document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-news-preview]').forEach((root) => { cleanups.get(root.id)?.(); cleanups.delete(root.id); }));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-discovery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cosmo-discovery-nav')) {
    customElements.define(
      'cosmo-discovery-nav',
      class CosmoDiscoveryNav extends HTMLElement {
        connectedCallback() {
          this.links = Array.from(this.querySelectorAll('a[href*="#products-"]'));
          this.targets = this.links
            .map((link) => {
              const hash = new URL(link.href, window.location.href).hash;
              return document.querySelector(hash);
            })
            .filter(Boolean);

          this.onClick = (event) => {
            const link = event.target.closest('a[href*="#products-"]');
            if (!link) return;
            const targetUrl = new URL(link.href, window.location.href);
            if (targetUrl.pathname !== window.location.pathname) return;
            const target = document.querySelector(targetUrl.hash);
            if (!target) return;
            event.preventDefault();
            target.scrollIntoView({
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
              block: 'start'
            });
          };
          this.addEventListener('click', this.onClick);

          this.observer = new IntersectionObserver((entries) => {
            const visible = entries
              .filter((entry) => entry.isIntersecting)
              .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
            if (!visible) return;
            this.links.forEach((link) => {
              const current = new URL(link.href, window.location.href).hash === '#' + visible.target.id;
              if (current) link.setAttribute('aria-current', 'true');
              else link.removeAttribute('aria-current');
            });
          }, { threshold: [0.15, 0.35] });

          this.targets.forEach((target) => this.observer.observe(target));
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          if (this.observer) this.observer.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
